// Slick Sliders
(function($){
    var blockLoaded = false;
    var blockLoadedInterval = setInterval(function() {
        if (document.getElementById('gallerySlider')) {
            $('#gallerySlider').slick({
                autoplay: true,
                autoplaySpeed: 1000,
                speed: 500,
                dots: true,
                appendDots: $(".slider-controls-gallery"),
                arrows: true,
                 prevArrow:"<button class='slick-btn-wrap slick-btn-left' type='button'><span class='slick-purple-btn'><i class='fas fa-chevron-left'></i></span></button>",
                nextArrow:"<button class='slick-btn-wrap slick-btn-right' type='button'><i class='fas fa-chevron-right'></i></i></button>",
                infinite: true,
                slidesToShow: 3,
                slidesToScroll: 1,
                swipe: true,
                swipeToSlide: true,
                margin:10,
                pauseOnHover:false,
                responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
            }
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,   
            }
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
            
            }
        }

  ]                
            });
            blockLoaded = true;
        }
        
        if ( blockLoaded ) {
            clearInterval( blockLoadedInterval );
        }
    }, 500);
})(jQuery);